module.exports = __webpack_public_path__ + "static/media/icon-trash.71c7a73f.svg";